export default "__VITE_ASSET__ivif30Eo__"